import { render, staticRenderFns } from "./SolutionCard.vue?vue&type=template&id=5bb71d40&scoped=true&"
import script from "./SolutionCard.vue?vue&type=script&lang=js&"
export * from "./SolutionCard.vue?vue&type=script&lang=js&"
import style0 from "./SolutionCard.vue?vue&type=style&index=0&id=5bb71d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb71d40",
  null
  
)

export default component.exports